package com.essntl.features.proposal.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.proposal.data")
class ProposalModule
